/* eslint-disable no-console */
/* eslint-disable max-len */
import { get, mapValues, uniqBy } from "lodash";
// import { createSelector } from "reselect";
import { addDays, format } from "date-fns";
// import { getDisplayTextUsingDatalistValue } from "../../utils/helper";
import { VAT_RETURN_DOCUMENTS } from "../../containers/PostEligibilityUploadDocuments/constants";
import { getIsLoadingDocuments } from "./uploadDocuments";
import { ensureBearerToken } from "../../utils/genericUtils";

import {
  UPLOADED,
  financeNames,
  DATE_FORMAT,
  UAE,
  GCC_OR_UAE_NATIONALITY_LIST,
  roSubmittedAppStatuses
} from "../../constants";

export const getAgentName = state => state.appConfig.login.userName;

export const getAppConfig = state => state.appConfig || {};

export const agentLoginStatus = state => state.login.loginStatus;

export const getDatalist = state => getAppConfig(state).datalist || {};

export const getSignatoryModel = state => getAppConfig(state).signatoryModel || {};

export const getRoSignatoryModel = state => getAppConfig(state).roSignatoryModel || {};

export const getReCaptchaSiteKey = state => getAppConfig(state).reCaptchaSiteKey;

export const getIsRecaptchaEnable = state => getAppConfig(state).recaptchaEnable;

export const getServicePricingGuideUrl = state => getAppConfig(state).servicePricingGuideUrl;

export const getAuthToken = state => getAppConfig(state).authorizationToken;

export const getRefreshToken = state => getAppConfig(state).refreshToken || undefined;

export const getProspect = state => getAppConfig(state).prospect || {};

export const getRoProspect = state => getAppConfig(state).roProspect || {};

export const getRoProspectModel = state => getAppConfig(state).roProspectModel || {};

export const getProspectDocument = state =>
  getRoProspect(state).financeInfo.proofOfEndUseMonitoring || {};

export const getSignatoryInvolvementProof = state =>
  getROSignatories(state).signatoryInvolvementProof || {};

export const getSignatories = state => getProspect(state).signatoryInfo || [];

export const getROSignatories = state => getRoProspect(state).signatoryInfo || [];

export const getSignatoriesCount = state => getSignatories(state).length;

export const getAccountInfo = state => getProspect(state).accountInfo || [];

export const getAccountType = state => {
  const accountType = getAccountInfo(state).accountType;
  return accountType || getApplicantInfo(state).productType;
};

export const getAccountCurrencies = state => get(getAccountInfo(state)[0], "accountCurrencies", "");

export const getOrganizationInfo = state => getProspect(state).organizationInfo || {};

export const getOrganizationInfoRO = state => getRoProspect(state).organizationInfoRO || {};
export const getFinanceInfoRO = state => getRoProspect(state).financeInfo || {};

export const getPrimaryMobCountryCode = state =>
  get(getOrganizationInfo(state), "contactDetails.primaryMobileCountryCode", "");

export const getCompanyName = state => getOrganizationInfo(state).companyName;

export const getSignboardProof = state =>
  getRoProspect(state).organizationInfoRO.premisesDetails.signboardProof || {};

export const getTelephoneOrDEWAProof = state =>
  getRoProspect(state).organizationInfoRO.additionalDetails.telephoneOrDEWAProof || {};

export const getOtherCompanySignboardProof = state =>
  getRoProspect(state).organizationInfoRO.premisesDetails.otherCompanySignboardProof || {};

export const getoutsourcedStaffProofDoc = state =>
  getRoProspect(state).organizationInfoRO.additionalDetails.outsourcedStaffProof || {};

export const getOrgKYCDetails = state => getProspect(state).orgKYCDetails || {};

export const getGeneralInfo = state => getProspect(state).generalInfo || {};

export const getProspectId = state => getGeneralInfo(state).prospectId || "";

export const getApplicantInfo = state => getProspect(state).applicantInfo || {};

export const getApplicantFullName = state => getApplicantInfo(state).fullName;

export const getTradeLicenseIssueDate = state => getApplicantInfo(state).tradeLicenseIssueDate;

export const getApplicationInfo = state => getProspect(state).applicationInfo || {};

export const getIsIslamicBanking = state => getApplicationInfo(state).islamicBanking || false;

export const getFinanceType = state => getApplicationInfo(state).financeType;

export const getRakValuePackage = state => getApplicationInfo(state).rakValuePackage || "";

export const getDocuments = state => getProspect(state).documents || {};

export const getRoDocuments = state => getRoProspect(state).documents || {};

export const getFreeFieldsInfo = state => getProspect(state).freeFieldsInfo || {};

export const getCompanyAddressProof = state => getOrganizationInfo(state).companyAddressProof || {};

export const getCompanyBankStatements = state => getDocuments(state).companyBankStatements || [];

export const getCompanyInvoices = state => getDocuments(state).companyInvoices || [];

export const getCompanyDocuments = state => getDocuments(state).companyDocuments || [];

export const getMobileNumber = state => getProspect(state).applicantInfo?.mobileNo || "";

export const getConsentEmailTriggerTime = state =>
  getApplicationInfo(state).consentEmailTriggerTime || "";

export const getApplyForAccount = state => getApplicationInfo(state).applyForAccount || false;

export const getDocumentUploadCnt = state => {
  const companyDocuments = getCompanyDocuments(state);
  let DocumentUploadCnt = 0;
  if (companyDocuments[0]) {
    DocumentUploadCnt = companyDocuments[0].DocumentUploadCnt;
  }
  return DocumentUploadCnt;
};

export const getStakeholdersDocuments = state => getDocuments(state).stakeholdersDocuments || [];

export const getOtherDocuments = state => getDocuments(state).otherDocuments || [];

export const checkIfRequiredDocsUploaded = (docs, type = null) => {
  return type
    ? docs.length &&
        docs
          .filter(doc => doc.required && doc.documentPosition === type)
          .every(doc => doc.uploadStatus === UPLOADED)
    : docs.length && docs.filter(doc => doc.required).every(doc => doc.uploadStatus === UPLOADED);
};

export const isRequiredUploaded = (doc, position) => {
  let flag = false;
  if (doc.documentPosition !== position || doc.required === false) {
    flag = true;
  } else if (doc.prospectDocument?.[0]?.uploadStatus === "Uploaded") {
    flag = true;
  }
  return flag;
};

export const getIsRequiredDocsUploaded = (state, type) => {
  if (process.env.REACT_APP_SKIP_UPLOAD === "Y") {
    return true;
  }
  const isLoadingDocuments = getIsLoadingDocuments(state);
  const isCompanyVATExempt = getOrganizationInfo(state).isCompanyVATExempt;
  const { companyDocuments, stakeholdersDocuments } = getDocuments(state);
  const {
    companyDocuments: roCompanyDocuments = [],
    stakeholdersDocuments: roStakeholdersDocuments
  } = getRoDocuments(state);
  if (isLoadingDocuments) return false;
  let validated = false;
  const filteredCompanyDocs = companyDocuments.filter(document => {
    let display = true;
    if (document.documentType === VAT_RETURN_DOCUMENTS && isCompanyVATExempt === "yes")
      display = false;
    return display;
  });
  validated = filteredCompanyDocs.every(doc => isRequiredUploaded(doc, type));
  if (validated) {
    let stakeholderUploaded = true;
    validated = Object.values(stakeholdersDocuments || {}).reduce((acc, { documents }) => {
      if (stakeholderUploaded) {
        stakeholderUploaded = documents.every(doc => isRequiredUploaded(doc, type));
      }
      return stakeholderUploaded;
    }, []);
  }
  if (validated) {
    validated = roCompanyDocuments.every(doc => isRequiredUploaded(doc, type));
  }
  if (validated) {
    validated = Object.values(roStakeholdersDocuments || {}).reduce((acc, { documents }) => {
      return documents.every(doc => isRequiredUploaded(doc, type));
    }, validated);
  }
  return validated;
};

export const getUrlsReadMore = state => ({
  rakValuePlusReadMoreUrl: getAppConfig(state).rakValuePlusReadMoreUrl,
  rakValueMaxReadMoreUrl: getAppConfig(state).rakValueMaxReadMoreUrl,
  rakValuePlusIslamicReadMoreUrl: getAppConfig(state).rakValuePlusIslamicReadMoreUrl,
  rakValueMaxIslamicReadMoreUrl: getAppConfig(state).rakValueMaxIslamicReadMoreUrl
});

export const getAuthorizationHeader = state => {
  const authToken = getAuthToken(state);
  const refreshToken = getRefreshToken(state);
  const mobileNo = getMobileNumber(state);
  const prospectId = getProspectId(state);
  const isAgentLoggedIn = agentLoginStatus(state);
  const headers = authToken ? { Authorization: ensureBearerToken(authToken) } : {};
  headers["stage-id"] = getApplicationInfo(state).viewId;
  if (mobileNo) {
    headers["mobile-no"] = mobileNo;
  }

  if (prospectId) {
    headers["prospect-id"] = prospectId;
  }

  if (refreshToken) {
    headers["refresh-token"] = refreshToken;
  }

  if (isAgentLoggedIn) {
    const agentName = getAgentName(state);
    if (agentName) {
      headers["user-id"] = agentName;
    }
  }
  return {
    headers: Object.keys(headers).length > 0 ? headers : {}
  };
};

export const createGetAuthorityTypeDisplayText = authorityTypes => state => {
  const authorityTypeFromDatalist = getDatalist(state).authorityType.reduce(
    (acc, dataListAuthority) => {
      if (
        authorityTypes.find(
          eachAuthority => eachAuthority.authorityType === dataListAuthority.value
        ) !== undefined
      ) {
        acc.push(
          dataListAuthority.displayText === "Other"
            ? authorityTypes[0].others
            : dataListAuthority.displayText
        );
      }
      return acc;
    },
    []
  );
  return authorityTypeFromDatalist.join(",");
};

export const getEmiratesList = state => getDatalist(state).emirateCity;
export const getLeadSource = state => {
  return typeof state.appConfig.leadSource !== "undefined"
    ? state.appConfig.leadSource.productName
    : "";
};

export const getExpired = state => getAppConfig(state).expired;

export const isBusinessFinanceType = state =>
  getFinanceType(state) === financeNames.businessFinance;

export const getSignatoryBankDetails = state => {
  const toDate = format(addDays(new Date(), -1), DATE_FORMAT);
  const fromDate = format(addDays(new Date(), -179), DATE_FORMAT);
  const { bankDetailsInUAE } = getOrgKYCDetails(state).otherBankingRelationshipsInfo;
  const orgKYCDetails = getOrgKYCDetails(state).otherBankingRelationshipsInfo;
  const { freeField2 = "" } = getFreeFieldsInfo(state);
  const signatories = getSignatories(state);
  const sigBankDetails = signatories[0] ? signatories[0].signatoryBankDetails : [];
  const userEditFlag = freeField2 === "" ? false : JSON.parse(freeField2);
  if (!orgKYCDetails.otherUAEBankAccountExist && userEditFlag) {
    return isEmpty(signatories[0].signatoryBankDetails)
      ? [
          {
            bankName: "",
            iban: "",
            fromDate,
            toDate
          }
        ]
      : signatories[0].signatoryBankDetails;
  } else if (
    !isEmpty(bankDetailsInUAE[0].iban) &&
    !orgKYCDetails.otherUAEBankAccountExist &&
    !userEditFlag
  ) {
    return bankDetailsInUAE.map(mig => ({
      bankName: "",
      iban: "",
      fromDate,
      toDate
    }));
  }

  if (
    sigBankDetails[0] &&
    !isEmpty(sigBankDetails[0].bankName) &&
    !isEmpty(sigBankDetails[0].iban) &&
    !isEmpty(sigBankDetails[0].fromDate) &&
    !isEmpty(sigBankDetails[0].toDate)
  ) {
    return sigBankDetails.map(mig => ({
      bankName: mig.bankName,
      iban: mig.iban,
      fromDate: mig.fromDate,
      toDate: mig.toDate
    }));
  }

  return bankDetailsInUAE.map(mig => ({
    bankName: mig.bankName,
    iban: mig.iban,
    fromDate,
    toDate
  }));
};

export const getIsAecbDetailsDisabled = state => {
  const orgKYCDetails = getOrgKYCDetails(state).otherBankingRelationshipsInfo;
  return !isEmpty(orgKYCDetails.bankDetailsInUAE[0].iban) && orgKYCDetails.otherUAEBankAccountExist;
};

export const getRoCode = state => {
  return typeof state.appConfig.roCode !== "undefined" ? state.appConfig.roCode : "";
};
export const getApplicationStatus = state => getAppConfig(state).applicationStatus.status;
export const getEligibleAmount = state =>
  getAppConfig(state).applicationStatus.eligibleAmount || "";

export const getSignatoryConsent = state => getApplicationInfo(state).consentDone || false;

export const getsignatoryEmails = state => {
  const sigWithEmails = getSignatories(state).filter(
    s => !isEmpty(s.contactDetails.preferredEmail)
  );
  return sigWithEmails.map(sig => ({
    key: sig.contactDetails.preferredEmail,
    code: sig.contactDetails.preferredEmail,
    displayText: sig.contactDetails.preferredEmail,
    value: sig.contactDetails.preferredEmail,
    subGroup: null
  }));
};

const isEmpty = str => !str || str.length === 0;

/**
 * Helper function to check if additional passport details are incomplete
 * @param {Array} additionalPassportDetails - Array of additional passport details
 * @returns {boolean} - True if any passport detail is incomplete
 */
export const hasIncompletePassportDetails = additionalPassportDetails => {
  return additionalPassportDetails.some(
    passport =>
      isEmpty(passport.passportNo) ||
      isEmpty(passport.passportIssuingCountry) ||
      isEmpty(passport.passportIssueDate) ||
      isEmpty(passport.signatoryPassportExpiryDate)
  );
};

export const getRoBorrowAmountRequiredFields = state => {
  const roFinance = getRoProspect(state).financeInfo;

  return (!isEmpty(roFinance.loanType) && !isEmpty(roFinance.financeType)) || false;
};
export const getIsRoStakeholderRequiredCompleted = state => {
  const signatories = getSignatories(state);
  return getROSignatories(state).every(
    (
      {
        gender,
        guarantorsStatus,
        signatoryCompanyInfo,
        visaNumber,
        visaExpiryDate,
        visaIssueDate,
        passportIssueDate,
        signatoryPassportExpiryDate,
        signatoryWorkExperience = {},
        additionalPassportDet
      },
      index
    ) => {
      if (!signatories[index]) {
        return true;
      }

      // Check additional nationality details
      const passportDetails = signatories[index]?.passportDetails || [];
      const additionalNationalitiesCount =
        passportDetails.length > 1 ? passportDetails.length - 1 : 0;
      const additionalPassportDetails = additionalPassportDet || [];

      if (additionalNationalitiesCount > 0) {
        if (additionalPassportDetails.length < additionalNationalitiesCount) {
          return false;
        }

        // Check if all additional passport details are fully filled
        if (hasIncompletePassportDetails(additionalPassportDetails)) {
          return false;
        }
      }

      if (signatories[index].isShareholderACompany === false) {
        const isUAEOrGCCNationality =
          signatories[index].residenceCountry !== UAE ||
          signatories[index].passportDetails
            .flatMap((item, index) => (item.nationality ? [item.nationality] : []))
            .some(ai => GCC_OR_UAE_NATIONALITY_LIST.includes(ai));

        if (isUAEOrGCCNationality) {
          return (
            !isEmpty(gender) &&
            !isEmpty(guarantorsStatus) &&
            !isEmpty(passportIssueDate) &&
            !isEmpty(signatoryPassportExpiryDate) &&
            !isEmpty(signatoryWorkExperience.signatoryBackgroundInfo)
          );
        } else {
          return (
            !isEmpty(gender) &&
            !isEmpty(guarantorsStatus) &&
            !isEmpty(passportIssueDate) &&
            !isEmpty(signatoryPassportExpiryDate) &&
            !isEmpty(visaNumber) &&
            !isEmpty(visaIssueDate) &&
            !isEmpty(visaExpiryDate) &&
            !isEmpty(signatoryWorkExperience.signatoryBackgroundInfo)
          );
        }
      } else {
        return !isEmpty(guarantorsStatus) && !isEmpty(signatoryCompanyInfo.dateOfIncorporation);
      }
    }
  );
};

export const getRoStakeholderMissingField = state => {
  const signatories = getSignatories(state);
  let msg = "";
  getROSignatories(state).every(
    (
      {
        gender,
        guarantorsStatus,
        signatoryCompanyInfo,
        visaNumber,
        visaExpiryDate,
        visaIssueDate,
        passportIssueDate,
        signatoryPassportExpiryDate,
        additionalPassportDet
      },
      index
    ) => {
      const fullname = signatories[index] ? signatories[index]?.fullName : "";
      if (fullname) {
        // Check additional nationality details
        const passportDetails = signatories[index]?.passportDetails || [];
        const additionalNationalitiesCount =
          passportDetails.length > 1 ? passportDetails.length - 1 : 0;
        const additionalPassportDetails = additionalPassportDet || [];

        if (additionalNationalitiesCount > 0) {
          if (additionalPassportDetails.length < additionalNationalitiesCount) {
            msg = fullname + "'s additional passport details are incomplete";
            return false;
          }

          // Check if all additional passport details are fully filled
          if (hasIncompletePassportDetails(additionalPassportDetails)) {
            msg = fullname + "'s additional passport details are incomplete";
            return false;
          }
        }

        if (signatories[index]?.isShareholderACompany === true) {
          if (isEmpty(guarantorsStatus)) {
            msg = fullname + "'s Guarantor status is missing";
          } else if (isEmpty(signatoryCompanyInfo.dateOfIncorporation)) {
            msg = fullname + "'s date of incorporation is missing";
          }
        } else if (
          signatories[index].residenceCountry !== UAE ||
          signatories[index].passportDetails
            .flatMap((item, index) => (item.nationality ? [item.nationality] : []))
            .some(ai => GCC_OR_UAE_NATIONALITY_LIST.includes(ai))
        ) {
          if (isEmpty(gender)) {
            msg = fullname + "'s gender is missing";
          } else if (isEmpty(guarantorsStatus)) {
            msg = fullname + "'s guarantor status is missing";
          } else if (isEmpty(passportIssueDate)) {
            msg = fullname + "'s passport issue date is missing";
          } else if (isEmpty(signatoryPassportExpiryDate)) {
            msg = fullname + "'s passport expiry date is missing";
          }
        } else {
          if (isEmpty(gender)) {
            msg = fullname + "'s gender is missing";
          } else if (isEmpty(guarantorsStatus)) {
            msg = fullname + "'s guarantor status is missing";
          } else if (isEmpty(visaNumber)) {
            msg = fullname + "'s visa number is missing";
          } else if (isEmpty(visaIssueDate)) {
            msg = fullname + "'s visa issue date is missing";
          } else if (isEmpty(visaExpiryDate)) {
            msg = fullname + "'s visa expiry date is missing";
          } else if (isEmpty(passportIssueDate)) {
            msg = fullname + "'s passport issue date is missing";
          } else if (isEmpty(signatoryPassportExpiryDate)) {
            msg = fullname + "'s passport expiry date is missing";
          }
        }
        return msg ? false : true;
      }
      return true;
    }
  );
  return msg;
};

export const getIsResidenceDetailsCompleted = state => {
  return getSignatories(state).every(
    ({ isSignatory, isShareholderACompany, kycDetails }, index) => {
      const guarantorsStatus =
        get(getROSignatories(state)[index], "guarantorsStatus", "No") === "Yes";
      const signatoryResAddress = kycDetails.addressInfo[0].addressDetails;
      return !isShareholderACompany && (isSignatory || guarantorsStatus)
        ? !isEmpty(signatoryResAddress.addressLine1) && !isEmpty(signatoryResAddress.addressLine2)
        : true;
    }
  );
};
export const getIsResidenceDetailsYearsInUaeCompleted = state => {
  return getSignatories(state).every(({ isSignatory, residenceCountry, kycDetails }) => {
    const signatoryResAddress = kycDetails.addressInfo[0].addressDetails;
    return isSignatory && residenceCountry === UAE
      ? !isEmpty(signatoryResAddress.yearsInUAE)
      : true;
  });
};
export const getLoanMinEligibleAmount = state => getDatalist(state).loanMinEligibleAmount;

export const getAecbButtonDuration = state => getDatalist(state).aecbButtonDuration;

export const getEligibilityStatus = state => getApplicationInfo(state).ipaStatus;

export const getPreEligibleAmount = state => getGeneralInfo(state).eligibleAmount || "";

export const getAdditionalDocumentsModel = state =>
  getAppConfig(state).additionalDocumentsModel || "";

export const getAdditionalDocuments = state => {
  let additionalDoc = getAdditionalDocumentsModel(state);
  let allAdditionalDocs = [];
  mapValues(additionalDoc.stakeholdersDocuments, stakeHolder => {
    allAdditionalDocs.push(...stakeHolder.documents);
  });

  allAdditionalDocs = [...allAdditionalDocs, ...additionalDoc.companyDocuments];
  const additionalDocs = uniqBy(allAdditionalDocs, "uniqueId");

  return additionalDocs.map(doc => ({
    key: doc.uniqueId,
    code: doc.uniqueId,
    displayText: doc.groupTitle,
    value: doc.uniqueId,
    subGroup: null
  }));
};

export const getProspectAdditionalDocuments = state =>
  getDocuments(state).additionalDocuments || [];

export const getUAEBankName = state => getDatalist(state).uaeBankName;

export const getSignatoriesEmail = (state, index) => {
  let emails = [];
  getSignatories(state).forEach((sig, sigIndex) => {
    if (index !== sigIndex) {
      emails.push(sig.contactDetails.preferredEmail);
    }
  });
  return emails;
};

export const getSignatoriesMobile = (state, index) => {
  let mobileNo = [];
  getSignatories(state).forEach((sig, sigIndex) => {
    if (index !== sigIndex) {
      mobileNo.push(
        `${sig.contactDetails.preferredMobileCountryCode}${sig.contactDetails.preferredMobileNo}`
      );
    }
  });
  return mobileNo;
};

export const getProspectCompletePercentage = state =>
  getApplicationInfo(state).completionPercentage || 0;

export const getIsExistingCustomer = state => getApplicationInfo(state).existingCustomer || false;
export const getIsApplicationSubmited = state => {
  const freeField = getFreeFieldsInfo(state).freeField6;
  if (freeField) {
    const { applicationSubmited = false } = JSON.parse(freeField);
    return applicationSubmited;
  }
  return false;
};

export const getFinanceInfo = state => getProspect(state).financeInfo || {};

export const getSignatoryById = signatoryId => state =>
  getSignatories(state).find(sig => sig.signatoryId === signatoryId);

export const getIsPreferredContactInfoOptional = (state, index) => {
  const passportDetails = get(getSignatories(state)[index], "passportDetails", []);
  const isSignatory = get(getSignatories(state)[index], "isSignatory", false);
  const guarantorsStatus = get(getROSignatories(state)[index], "guarantorsStatus", "No") === "Yes";

  return (
    passportDetails.some(({ nationality }) => nationality === UAE) &&
    !isSignatory &&
    !guarantorsStatus
  );
};

export const getLicenseIssuingAuthority = state => getDatalist(state).licenseIssuingAuthority;

export const getaecCCY = state => getDatalist(state).aecCCY;

export const getIsRoComplianceConfirmationCompleted = state => {
  const complianceConfirmation = get(
    getOrganizationInfoRO(state),
    "complianceConfirmation.dealWithSyrianProduct",
    ""
  );
  return !isEmpty(complianceConfirmation);
};

export const getIsRoCustHaveExistCifCompleted = state => {
  const custHaveExistCifConfirmation = get(getApplicationInfo(state), "custHaveExistCif", "");
  return !isEmpty(custHaveExistCifConfirmation);
};

export const getDatalistSearch = state => getAppConfig(state).datalistSearch || [];

export const getCities = state => getDatalist(state).city;

export const getCountriesList = state => getDatalist(state).country;

export const allowStakeholderDelete = state => {
  const appStatus = get(getApplicationInfo(state), "appStatus", "");
  return !roSubmittedAppStatuses.includes(appStatus);
};
